// TDM Needs fixing  (see FAQ page)
import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
`;
const Inner = styled.div`
  height: 116px;
  background-color: #ff5368;

  width: calc(100% - 50px);
  margin: 25px;
  float: left;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1100px) {
    flex-wrap: wrap;
    align-content: flex-start;
  }
  @media (max-width: 700px) {
    margin: 0;
    width: 100%;
    height: auto;

    display: block;
  }
`;
const Title = styled.div`
  height: 58px;
  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.07;
  letter-spacing: 0.4px;
  color: #ffffff;
  @media (max-width: 1100px) {
    width: 100%;

    font-size: 20px;
    line-height: 2.9;
    letter-spacing: 0.3px;
    text-align: center;
  }
  @media (max-width: 700px) {
    font-size: 18px;
    line-height: 22px;
    height: auto;

    width: calc(100% - 46px);
    float: left;
    margin: 36px 23px 23px 23px;
  }
`;
const Field = styled.input`
  width: 389px;
  height: 24px;
  opacity: 0.8;
  font-family: Lato;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: #ffffff;

  padding: 9px 22px 12px 22px;
  border: 0;

  flex-shrink: 1;

  border-radius: 5px;
  background-color: rgb(255, 100, 119);
  margin: 0 34px;
  @media (max-width: 1100px) {
    width: 90px;
    flex-shrink: 0;
    flex-grow: 1;
    margin: 0 20px;
  }
  @media (max-width: 700px) {
    float: left;
    margin: 0 23px;
    padding: 6px 12px 8px 12px;
    width: calc(100% - 70px);

    height: 17px;
    font-size: 14px;
    letter-spacing: 0.2px;
  }
`;
const Button = styled.input`
  font-family: Lato;
  font-size: 14px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  background-color: #ff5368;
  color: #ffffff;

  padding: 12px 25px 9px 25px;
  border-radius: 5px;
  border: solid 1px #ffffff;
  text-transform: uppercase;
  @media (max-width: 1100px) {
    margin-right: 20px;
  }
  @media (max-width: 700px) {
    margin-right: 0;
  }
  :hover {
    background-color: rgb(255, 100, 119);
    cursor: pointer;
  }
`;
const ButtonContainer = styled.div`
  @media (max-width: 700px) {
    width: 100%;
    float: left;
    display: flex;
    margin: 22px 0 26px 0;
    justify-content: center;
  }
`;

class Newsletter extends Component {
  render() {
    let auctionBaseUrl = "/portal";
    if (
      this.props.auction &&
      this.props.auctions &&
      this.props.auctions[this.props.auction] &&
      this.props.auctions[this.props.auction].url
    ) {
      auctionBaseUrl = this.props.auctions[this.props.auction].url;
    }

    return (
      <form method="POST" action={auctionBaseUrl + "/news_letter_subscribe"}>
        <Wrapper>
          <Inner>
            <Title>{this.props.content.title}</Title>
            <Field name="email" placeholder="Your E-mail" />
            <ButtonContainer>
              <Button type="submit" name="subscribe" value="Sign up" />
            </ButtonContainer>
          </Inner>
        </Wrapper>
      </form>
    );
  }
}

const mapStateToProps = state => {
  return {
    auction: state.auction.data,
    auctions: state.auctions.data,
    contentMenu: state.contentMenu.data,
    translations: state.translations.data
  };
};

export default connect(mapStateToProps)(Newsletter);



// WEBPACK FOOTER //
// ./src/components/Newsletter.js